import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

const NumberFormatCustom = props => {
  const {
    inputRef,
    onChange,
    fixedDecimalScale,
    decimalScale,
    withValueLimit,
    defaultValue,
    ...other
  } = props;

  // Funzione per il controllo del valore
  const isAllowed = values => {
    const { value } = values;

    // Consenti il segno meno come primo carattere, ma solo se seguito da numeri
    if (value === '' || value === '-') return true;

    // Converte il valore in numero
    const numericValue = parseFloat(value);

    // Se il valore non è numerico e non è solo il segno meno
    if (isNaN(numericValue)) {
      return true;
    }

    // Applica il limite se è presente (verifica con 'withValueLimit')
    if (typeof withValueLimit === 'function') {
      if (!withValueLimit({ value: numericValue })) {
        return false; // Se non supera il limite, non è permesso
      }
    }

    // Se il limite richiede numeri positivi, impediamo il segno negativo
    if (
      withValueLimit &&
      typeof withValueLimit === 'object' &&
      withValueLimit.min > 0 &&
      value.startsWith('-')
    ) {
      return false; // Limita i numeri negativi se min è maggiore di 0
    }

    return true; // Se il valore è valido
  };

  return (
    <NumberFormat
      getInputRef={inputRef}
      onValueChange={(values, sourceInfo) => {
        // react-number-format rilancia onValueChange anche quando il valore
        // cambia per motivi NON legati a un input dell'utente (es. al mount,
        // riformatta il defaultValue applicando decimalScale/fixedDecimalScale
        // — "23" arrivato da backend diventa "23.00"). sourceInfo.source vale
        // 'event' solo per un vero input utente, 'prop' per un cambio
        // programmatico: propagare solo il primo evita che questa
        // riformattazione automatica sporchi isDirty (letto in
        // Accordion5CdaL3.jsx per UnsavedChangesWarning) subito all'apertura
        // della tab, senza alcuna modifica reale dell'utente.
        if (sourceInfo?.source !== 'event') return;
        onChange({
          target: {
            value: values.value || '',
          },
        });
      }}
      thousandSeparator={'.'}
      decimalSeparator={','}
      fixedDecimalScale={fixedDecimalScale}
      decimalScale={decimalScale}
      type="text"
      // isAllowed={withValueLimit}
      isAllowed={isAllowed}
      isNumericString
      defaultValue={defaultValue}
      {...other}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.objectOf(PropTypes.func),
  onChange: PropTypes.func,
  fixedDecimalScale: PropTypes.bool,
  decimalScale: PropTypes.number,
  withValueLimit: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

NumberFormatCustom.defaultProps = {
  fixedDecimalScale: true,
  decimalScale: 2,
  withValueLimit: true,
};

export default NumberFormatCustom;
